import React from 'react';
import PropTypes from 'prop-types';

const RADIUS = 8;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const LearningInProgressIcon = ({color = 'currentColor', percent = 0, ...props}) => {
  const safePercent = Math.max(0, Math.min(100, percent));
  const dash = (safePercent / 100) * CIRCUMFERENCE;

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="10" cy="10" r={RADIUS} fill="none" stroke={color} strokeOpacity="0.25" strokeWidth="1.6" />
      <circle
        cx="10"
        cy="10"
        r={RADIUS}
        fill="none"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeDasharray={`${dash} ${CIRCUMFERENCE}`}
        transform="rotate(-90 10 10)"
      />
    </svg>
  );
};

LearningInProgressIcon.propTypes = {
  color: PropTypes.string,
  percent: PropTypes.number,
};

export default LearningInProgressIcon;
